var exports = {
  "x": "x31de4314--5be0e0--thumbnail",
};

module.exports = exports;
